import script from "./KidneyElectrolytes.vue?vue&type=script&setup=true&lang=js"
export * from "./KidneyElectrolytes.vue?vue&type=script&setup=true&lang=js"

import "./KidneyElectrolytes.vue?vue&type=style&index=0&id=6a00ec02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a00ec02"]])

export default __exports__